import parsePhoneNumberFromString, { CountryCode } from "libphonenumber-js";

export class PhoneNumberHelper {
  static isPhoneNumberValid(phoneNumber?: string, countryCodes?: string[]): string | undefined {
    if (!phoneNumber) {
      return undefined;
    }
    const countries: CountryCode[] = countryCodes && countryCodes.length ? (countryCodes as CountryCode[]) : (["US"] as CountryCode[]);
    let validPhoneNumber: string | undefined = undefined;

    for (let i = 0; i < countries.length; i++) {
      const parsedPhoneNumber = parsePhoneNumberFromString(phoneNumber, countries[i]);

      if (parsedPhoneNumber && parsedPhoneNumber.isValid()) {
        validPhoneNumber = parsedPhoneNumber.number as string;

        return validPhoneNumber;
      }
    }
    return validPhoneNumber;
  }

  static normalizePhoneNumber(phoneNumber: string, countryCodes: string[]): string | undefined {
    return PhoneNumberHelper.isPhoneNumberValid(phoneNumber, countryCodes);
  }
}
